<template>
  <div>
    <div :style="styleY() + styleX()">
      <HeaderRelatorio 
        v-if="header" 
        :block_endereco="true" 
        :forceheader="forceheader" 
        :id_unidade_operacao="id_unidade_operacao" 
        :logo_url="logo_url"
        :parms="parms" />
      <div>
        <div class="d-flex flex-column" style="font-size: 20pt;">
          <slot></slot>
        </div>
        <div
          class="d-flex flex-column text-center"
          style="position: fixed; left: 0; bottom: 0; width: 100%; page-break-after: always; break-after: always; font-size: 16pt;"
          :style="styleY() + styleX()"
        >
          <slot name="rodape"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import _ from "lodash";
// import * as moment from "moment";
import HeaderRelatorio from "./shared/HeaderRelatorio";

export default {
  data() {
    return {
      unidade: null,
      papel: "A4"
    };
  },
  components: {
    HeaderRelatorio
  },
  props: {
    header: {
      type: Boolean,
      default: false
    },
    dados: {
      type: Object
    },
    pageSize: {
      type: String,
      default: "A4"
    },
    forceheader: { 
      type: Boolean,
      default: false
    },
    id_unidade_operacao: { 
      type: Number,
      default: null, 
    },
    logo_url: { 
      type: String,
      default: null
    },
    parms: { 
      type: Object,
      default: null
    }
  },
  methods: {
    configurarPapel(tipoPapel) {
      this.papel = tipoPapel;
      //this.pageSize = tipoPapel;
    },
    calculaMargemTop() {
      if (this.unidade ) {
        if (this.pageSize && this.pageSize === "A4") {
          if (this.unidade.in_margem_superior_a4) {
            return this.unidade.in_margem_superior_a4;
          } else return 0;
        } else if (this.pageSize && this.pageSize === "A5") {
          if (this.unidade.in_margem_superior_a5) {
            return this.unidade.in_margem_superior_a5;
          } else return 0;
        } else return 0;
      } else return 0;
    },
    calculaMargemLeft() {
      if (this.unidade ) {
        if (this.pageSize && this.pageSize === "A4") {
          if (this.unidade.in_margem_esquerda_a4) {
            return this.unidade.in_margem_esquerda_a4;
          } else return 0;
        } else if (this.pageSize && this.pageSize === "A5") {
          if (this.unidade.in_margem_esquerda_a5) {
            return this.unidade.in_margem_esquerda_a5;
          } else return 0;
        } else return 0;
      } else return 0;
    },
    calculaMargemRight() {
      if (this.unidade ) {
        if (this.pageSize && this.pageSize === "A4") {
          if (this.unidade.in_margem_direita_a4) {
            return this.unidade.in_margem_direita_a4;
          } else return 0;
        } else if (this.pageSize && this.pageSize === "A5") {
          if (this.unidade.in_margem_direita_a5) {
            return this.unidade.in_margem_direita_a5;
          } else return 0;
        } else return 0;
      } else return 0;
    },
    calculaMargemBottom() {
      if (this.unidade ) {
        if (this.pageSize && this.pageSize === "A4") {
          if (this.unidade.in_margem_inferior_a4) {
            return this.unidade.in_margem_inferior_a4;
          } else return 0;
        } else if (this.pageSize && this.pageSize === "A5") {
          if (this.unidade.in_margem_inferior_a5) {
            return this.unidade.in_margem_inferior_a5;
          } else return 0;
        } else return 0;
      } else return 0;
    },
    styleY(type) {
      let style = 
        ( type ? type : 'padding' ) + '-top' + ": " + this.calculaMargemTop() + "cm; " +
        ( type ? type : 'padding' ) + '-bottom: ' + this.calculaMargemBottom() + "cm; " 
        /*
        "size: " +
        this.pageSize +
        ";"
        */

      return style;
    },
    styleX(type) {
      let style = 
        ( type ? type : 'padding' ) + '-right' + ": " + this.calculaMargemRight() + "cm; " +
        ( type ? type : 'padding' ) + '-left: ' + this.calculaMargemLeft() + "cm; ";

      return style;
    }
  },
  watch: {
    pageSize() {
      this.$forceUpdate();
    }
  },
  mounted() {
    this.unidade = this.$store.state.unidade;
  }
};
</script>

<style>
</style>
